import { Scissors, Sparkles, Feather, Hand, Brush, UserRound, MessageCircle, ArrowUpRight } from "lucide-react";
import { services, waLink } from "@/config/business";
import { Reveal, Overline } from "@/components/Reveal";

const icons = {
  scissors: Scissors,
  sparkles: Sparkles,
  feather: Feather,
  hand: Hand,
  brush: Brush,
  user: UserRound,
};

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-32 bg-cream" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <Reveal>
          <Overline>Our Services</Overline>
          <div className="mt-4 flex flex-wrap items-end justify-between gap-6">
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-ink max-w-xl">
              Beauty Services, All in One Place
            </h2>
            <p className="text-muted-foreground text-base max-w-sm">
              From everyday grooming to occasion-ready looks — enquire on WhatsApp for details and a quick quote.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = icons[s.icon];
            return (
              <Reveal key={s.title} delay={(i % 3) * 0.08}>
                <article
                  data-testid={`service-card-${i}`}
                  className="group relative bg-white border border-primary/10 p-8 flex flex-col gap-5 h-full hover:shadow-[0_20px_50px_rgba(59,26,48,0.10)] hover:-translate-y-1 transition-[box-shadow,transform] duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-soft text-primary group-hover:bg-primary group-hover:text-cream transition-colors">
                    <Icon size={22} aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="font-display text-2xl text-ink">{s.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
                  </div>
                  <a
                    data-testid={`service-whatsapp-${i}`}
                    href={waLink(`Hi Lavniya! I'd like to enquire about ${s.title}.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto inline-flex items-center gap-2 text-sm font-semibold text-wa hover:gap-3 transition-[gap] min-h-[44px]"
                    aria-label={`Enquire about ${s.title} on WhatsApp`}
                  >
                    <MessageCircle size={16} /> Enquire on WhatsApp <ArrowUpRight size={14} />
                  </a>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
